import { SIMPLE_DATE_TIME } from '../constants/dates';
import dateFormatter from './dateFormatter';

export default function simpleDateTime(date: any, timeZone: any) {
  return dateFormatter(date, SIMPLE_DATE_TIME, timeZone);
}
